import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17 4H7c-.5523 0-1 .4477-1 1v14c0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1V5c0-.5523-.4477-1-1-1zM7 19V6h10v13H7z',
  ],
  height: 24,
  width: 24,
});
